import React, { useCallback, useState, useEffect } from "react";
import PropTypes from "prop-types";
import Transfer from "../../../../components/shared/Transfer";
import { useTextResources } from '../../../../language';

const ExcludeCustomersTransfer = ({
    promotionExcludedCustomersIds,
    promotionCustomers,
    onChange,
}) => {
    const text = useTextResources();
    const [targetKeys, setTargetKeys] = useState([]);

    useEffect(() => {
        setTargetKeys(promotionExcludedCustomersIds);
    }, [promotionExcludedCustomersIds])

    useEffect(() => {
        onChange(targetKeys);
    }, [targetKeys, onChange])

    const searchSelector = useCallback((customer, searchTerm) => {
        return itemRender(customer)?.toLowerCase().includes(searchTerm?.toLowerCase());
    }, []);

    const handleCustomersChange = useCallback((keys) => {
        setTargetKeys(keys);
    }, []);

    const keySelector = useCallback((customer) => customer.EntityId, []);
    const itemRender = useCallback((customer) => {
        return `${customer?.Name} - ${customer?.Rates.map(r => r.Name).join(', ')}`;
    }, []);

    return (
        <Transfer
            items={promotionCustomers}
            itemKeySelector={keySelector}
            itemRender={itemRender}
            targetKeys={targetKeys}
            targetListLabel={text("ExcludedCustomers")}
            sourceListLabel={text("IncludedCustomersForBaseRates")}
            hasSearch
            searchSelector={searchSelector}
            hasSelectAll
            onTargetKeysChange={handleCustomersChange}
            isSourceShownOnRightSide
        />
    );
};

ExcludeCustomersTransfer.propTypes = {
    promotionExcludedCustomersIds: PropTypes.array.isRequired,
    promotionCustomers: PropTypes.array,
    onChange: PropTypes.func.isRequired,
};

export default ExcludeCustomersTransfer;